import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {jobProfileConfig_template} from "./jobProfileConfig_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";

declare var ko: any;

export class jobProfilesList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected config: jobProfileConfig_template;
    protected brandFilter: multipleSelector_template;
    protected statusFilter: multipleSelector_template;
    protected filterPreset: filterPreset_template;

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header filter-preset w-justify">

                    ` + this.filterPreset.getHtmlBuild() + `
            </div>
            <div class="sub-header w-justify">
                <div class="w-left">
                    ` + this.brandFilter.getHtmlBuild() + ` 
                    ` + this.statusFilter.getHtmlBuild() + ` 
                </div>
            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brandType"></div>
                </div>
            </div> 
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-statusType"></div>
                </div>
            </div> 
            
            <div class="list-header w-justify" >

                <div class="w-left" data-bind="if: isAddButtonShown">
                
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-profiles" type="button">Create Profile</button>
                    
                    <div class="">
                        <button data-bind="click: onClickConfig" class="btn secondary icon i-settings" type="button" style="margin-left: 1rem;">Website Config</button>
                        <ul  data-bind="foreach: brands, css: { 'is-hidden': !isBrandListShown()}" class="main-nav-list brand-list">
                            <li class="main-nav-item">
                                <button class="main-nav-link" data-bind="click: $parent.onClickBrandConfig, css: iconImage"></button> 
                            </li>
                        </ul>
                    </div>
                    
                </div>

                <div class="w-center">
                         ` + this.filter.getHtmlBuild() + `
                </div>

                <div class="w-right">
                    <div data-bind="style: { display: paginationIsVisible() ? 'block' : 'none' }">
                        <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                            <div class="pagination">
                                <input data-bind="value: pageNumber" type="hidden" value="1">
                                <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                                <ul data-bind="foreach: pages">
                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                                </ul>
                                <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    ` + this.config.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brand') }, css: { 'list-sort-desc': orderByAndDirection()=='brand_DESC', 'list-sort-asc': orderByAndDirection()=='brand_ASC' }">Brand</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Postion Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'role') }, css: { 'list-sort-desc': orderByAndDirection()=='role_DESC', 'list-sort-asc': orderByAndDirection()=='role_ASC' }">Role</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'networkCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='networkCategory_DESC', 'list-sort-asc': orderByAndDirection()=='networkCategory_ASC' }">Network Category</span></th>
                            <th><span class="icon list-sort-none">Permitted GEOs</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isActive') }, css: { 'list-sort-desc': orderByAndDirection()=='status_DESC', 'list-sort-asc': orderByAndDirection()=='status_ASC' }">Status</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'lastDateEnabled') }, css: { 'list-sort-desc': orderByAndDirection()=='lastDateEnabled_DESC', 'list-sort-asc': orderByAndDirection()=='lastDateEnabled_ASC' }">Last Date Enabled</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'lastDateDisabled') }, css: { 'list-sort-desc': orderByAndDirection()=='lastDateDisabled_DESC', 'list-sort-asc': orderByAndDirection()=='lastDateDisabled_ASC' }">LAst Date Disabled</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Created On</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Updated On</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: profiles">
    
                        <tr  class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: brand.name"></span><a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: name"></span><a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: role ? role.name : ''"></span><a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: networkCategory ? networkCategory.name : ''"></span><a></td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a class="right-click" data-bind="foreach: geos, attr: { href : emakiView }">
                                    <span data-bind="text: name + ','"></span>
                                <a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: isActive == 0 ? 'Disabled' : 'Enabled'"></span><a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: lastDateEnabled"></span><a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: lastDateDisabled"></span><a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span><a></td>
                            <td data-bind="event: { click: $parent.onClickView }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated"></span><a></td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>   
            
            `;
    }

    protected initPartial(): void {

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.config = new jobProfileConfig_template("config", this.getTemplateViewModel(), this.caller);

        this.brandFilter = new multipleSelector_template("brandFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel("brand");
        this.brandFilter.setFilterContainerClass('margin-neg');
        this.brandFilter.setTagContainerId('selected-brandType');
        this.brandFilter.setTagContainerCaption('Selected brand type:');

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("Status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-statusType');
        this.statusFilter.setTagContainerCaption('Selected Status type:');

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('jobProfile');
    }

    protected getTemplateName(): string {
        return "jobProfilesList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("name")
            , orderByDirection: ko.observable("ASC")
            , profiles: ko.observableArray([])
            , brands: ko.observableArray([])
            , activeConfigBrand: ko.observable(null)
            , isBrandListShown: ko.observable(false)
            , orderByAndDirection: ko.observable("name_ASC")
            , isAddButtonShown: ko.observable(false)
            , paginationIsVisible: ko.observable(false)
            , onClickReorder: function (value, data, event) { huit_neuf_this.onClickReorder(value, data, event); }
            , onClickView: function (data, event) { huit_neuf_this.onClickView(data); }
            , onClickAdd: function () { huit_neuf_this.onClickAdd(); }
            , onClickConfig: function (data, event) { huit_neuf_this.onClickConfig(); }
            , onClickBrandConfig: function (data, event) { huit_neuf_this.onClickBrandConfig(data); }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
              orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            , searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName()
            , searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType()
            ,filters : {
                keywords : this.getTemplateViewModel().filter.filterKeyword,
                brandIds: this.brandFilter.getSelectedItems(),
                statusIds: this.statusFilter.getSelectedItems(),
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.jobProfileListReorder();
    }

    public onClickView(data) {

        this.caller.viewProfile(data);
    }

    public onClickAdd() {

        this.caller.addJobProfile();
    }

    public onClickConfig() {

        this.getTemplateViewModel().isBrandListShown(!this.getTemplateViewModel().isBrandListShown());
    }

    public onClickBrandConfig(data) {

        this.onClickConfig();
        this.getTemplateViewModel().activeConfigBrand(data)
        this.caller.filterBrandList(data)
    }

    public setProfiles(profiles) {

        profiles.forEach((p) => {
            p['emakiView'] = '/job/profiles/view/' + p.id;
            p['lastDateDisabled'] = p.lastDateDisabled ? p.lastDateDisabled.split('.')[0] : null;
            p['lastDateEnabled'] = p.lastDateEnabled ? p.lastDateEnabled.split('.')[0] : null;
            p['dateCreated'] = p.dateCreated ? p.dateCreated.split('.')[0] : null;
            p['dateUpdated'] = p.dateUpdated ? p.dateUpdated.split('.')[0] : null;
        });

        this.getTemplateViewModel().profiles(profiles);
    }

    public setSortables(sortables) {

        this.config.setSortables(sortables);
        this.config.togglePopUp(true);
    }

    public setBrands(brands) {

        this.getTemplateViewModel().brands(brands);
        this.brandFilter.setItems(brands);
    }

    public setStatus(status) {

        this.statusFilter.setItems(status);
    }

    public setAddButtonShown(isAddButtonShown: boolean) {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setResultInfo(nbResults, nbPages, execTime, updateExecTime = true) {

        if(updateExecTime)  this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setSearchPresets(presets){

        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){

        this.filterPreset.addCreatedPresetToList(response);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            this.setFilterSelectedItems(this.brandFilter, urlParams.brandIds);
            this.setFilterSelectedItems(this.statusFilter, urlParams.statusIds);
        }
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else if(Array.isArray(urlParams)){
                splitString = urlParams;
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public resetActiveConfigBrand(){

        this.getTemplateViewModel().activeConfigBrand(null);
    }

    public setPaginationIsVisible(isVisible){
        this.getTemplateViewModel().paginationIsVisible(isVisible);
    }

    public setExecutionTime(execTime){
        this.resultInfos.setExecutionTime(execTime);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/jobProfilesList_template.ts